<template>
  <WorkPackageSubPageModule
    :workpackage="{textcolor: '#fff'}"
    :isMobile="true"
    :location="location"
    :loading="false"
    :background_color="'#424242'"
    :foreground_color="'#fff'"
    :header_icon="$store.state.Ultra.step_icons[step_type.toLowerCase()]"
    :header_text_short="$t(`WorkpackageRework.Steps.Types.${step_type}`)"
    :header_text_long="$t(`WorkpackageRework.Steps.Types.${step_type}`) + '.' + $t(`WorkpackageRework.Steps.steps`)"
    @headerBack="$router.push({name: `${location}TaktareaDetailsSteps`})"
    >
    <template #header-rightside>
      <RadialCheckbox
        :id="step.id"
        :is_checked="step.done || step.status === 'done'"
        large
        :background_color="'#424242'"
        :foreground_color="'#fff'"
        style="margin: 0px 8px;"
      />
    </template>
    <template #body>
      <LabelOutlined
        :label="$t(`WorkpackageRework.Steps.Types.${step_type}`) + '.' + $t(`WorkpackageRework.Steps.step`) + ' ' + $t(`WorkpackageRework.Steps.status`)"
        :background_color="'#424242'"
        :dark="false"
      >
        <template #content>
          <div class="work-package-step-detail-status-container">
            <ButtonOutlined
              class="work-package-step-detail-status-button"
              :style="`background-color: ${step.done || step.status === 'done'? '#424242' : '#fff'};`"
              icon="checkbox-radial-empty"
              text="Open"
              :color="step.done || step.status === 'done'? '#fff' : '#424242'"
            />
            <ButtonOutlined
              class="work-package-step-detail-status-button"
              :style="`background-color: ${step.done || step.status === 'done'? '#fff' : '#424242'};`"
              icon="checkbox-radial-filled"
              text="Done"
              :color="step.done || step.status === 'done'? '#424242' : '#fff'"
            />
          </div>
        </template>
      </LabelOutlined>
      <TextArea
        :value="step.text"
        :label="$t('WorkpackageRework.Steps.Description')"
        :placeholder="`Describe the ${$t(`WorkpackageRework.Steps.Types.${step_type}`) + '.' + $t(`WorkpackageRework.Steps.step`)}...`"
        :height="170"
        :background_color="'#424242'"
        :foreground_color="'#fff'"
        :is_disabled="true"
      />
      <template v-if="step_type === 'Work'">
        <ModularEquation
          :description="'Time Effort'"
          :id="'Time Effort'"
          :elements="[
            { label: 'Value', id: 'Value', /*width: 85,*/ value: step.performance_value, is_disabled: true, input_type: 'number'},
            { operator: 'mh /'},
            { label: 'Reference Unit', id: 'Reference Unit', width: 125, value: $store.state.Ultra.expense_units.find(unit => unit.value === step.mass_relation), is_disabled: true, select: {options: $store.state.Ultra.expense_units}},
          ]"
          :background_color="'#424242'"
          :foreground_color="'#fff'"
        />
      </template>
      <template v-if="step_type === 'Material'">
        <ModularEquation
          :description="'Material Conversion'"
          :id="'Material Conversion'"
          :elements="[
            { label: 'Factor', id: 'Factor', /*width: 85,*/ value: step.conversion_factor, is_disabled: true, input_type: 'number'},
            { label: 'Unit', id: 'Unit', width: 100, value: $store.state.Ultra.conversion_units.find(unit => unit.value === step.conversion_unit), is_disabled: true, select: {options: $store.state.Ultra.conversion_units}},
            { operator: '/'},
            { label: 'Reference Unit', id: 'Reference Unit', width: 105, value: $store.state.Ultra.expense_units.find(unit => unit.value === step.mass_relation), is_disabled: true, select: {options: $store.state.Ultra.expense_units}},
          ]"
          :is_disabled="true"
          :background_color="'#424242'"
          :foreground_color="'#fff'"
        />
        <DropDownOutlinedFlat
          :label="$t('WorkpackageRework.Steps.WorkstepLink')"
          :value="workstep_link"
          :is_disabled="true"
          :background_color="'#424242'"
          :foreground_color="'#fff'"
          style="width: 100%;"
        />
      </template>
      <DisableableInputField
        v-if="!['Work', 'Material'].includes(step_type)"
        class="mt-2 mb-2"
        :label="$t('WorkpackageRework.Steps.Offset') + '[' + $t('WorkpackageRework.Steps.TaktTimes') + ']'"
        input_type="number"
        unit="TT"
        :value="step.offset"
        :is_disabled="true"
        :background_color="'#424242'"
        :foreground_color="'#fff'"
      />
      <!-- Elements -->
      <!-- <CollapsableCategory
        v-if="['Work', 'Material'].includes(step_type)"
        class="mt-2"
        :description="`Elements (${step_type === 'Work'?(step.elements?step.elements.length:0):(step.tworksteps.length !== 0?$store.state.Ultra.tworksteps[step.tworksteps[0]].elements.length:0)})`"
        :color="'#fff'"
      >
      <template #header-middle="{ is_collapsed }">
        <template v-if="is_collapsed && !['absolute', 'none'].includes(step.mass_relation)">
          <div class=" mr-3 step-elements-total-value">{{calcStepTotal(step, step_type).total_mass}} {{getMassRelationUnit(step.mass_relation)}}</div>
          <div class="step-elements-total-value">{{calcStepTotal(step, step_type).value}} {{calcStepTotal(step, step_type).unit}}</div>
        </template>
      </template>
      <template #content="{ is_collapsed }">
        <template v-if="!is_collapsed">
          <template v-if="(step_type === 'Work' && step.elements.length !== 0) || (step_type === 'Material' && step.tworksteps.length !== 0 && $store.state.Ultra.tworksteps[step.tworksteps[0]].elements.length !== 0)">
          <div class="mb-2 d-flex step-elements-calculation" :style="`color: ${'#fff'}`">
            <div v-if="step_type === 'Work'">{{step.performance_value}} mh/{{getMassRelationUnit(step.mass_relation)}}</div>
            <div v-else-if="step_type === 'Material'">{{step.conversion_factor}} {{step.conversion_unit}}/{{getMassRelationUnit(step.mass_relation)}}</div>
            <div class="step-elements-calculation-operator">*</div>
            <div class="step-elements-total-value">{{calcStepTotal(step, step_type).total_mass}} {{getMassRelationUnit(step.mass_relation)}}</div>
            <div class="step-elements-calculation-operator">=</div>
            <div class="step-elements-total-value">{{calcStepTotal(step, step_type).value}} {{calcStepTotal(step, step_type).unit}}</div>
           </div>
           <div
            v-for="element_wrapper in getChildElements({parent_type: 'tworksteps', parent_id: step_type === 'Work'?step.id:step.tworksteps[0]})"
            :key="element_wrapper.ifc_type"
            >
            <div class="step-elements-wrapper" :style="`color: ${'#fff'}`">
              <div
                class="d-flex justify-space-between mt-2 mb-2 cursor-pointer"
                @click="handleElementWrapperClick(element_wrapper.ifc_type)"
                >
                <div class="d-flex">
                  <v-icon :color="'#fff'" small>{{element_wrappers_open.includes(element_wrapper.ifc_type)?'keyboard_arrow_down':'keyboard_arrow_right'}}</v-icon>
                  <div>{{element_wrapper.ifc_type}}s ({{element_wrapper.elements.length}})</div>
                </div>
                <div class="d-flex">
                  <div class="mr-3 step-elements-total-value">{{calcStepTotal(step, step_type, element_wrapper.element_ids).total_mass}} {{getMassRelationUnit(step.mass_relation)}}</div>
                  <div class="step-elements-total-value" v-if="step.mass_relation !== 'none'">{{calcStepTotal(step, step_type, element_wrapper.element_ids).value}} {{calcStepTotal(step, step_type, element_wrapper.element_ids).unit}}</div>
                </div>
              </div>
              <template v-if="element_wrappers_open.includes(element_wrapper.ifc_type)">
                <div
                  class="d-flex justify-space-between"
                  style="margin-left: 16px"
                  v-for="(element, index) in element_wrapper.elements"
                  :key="element.id"
                  >
                  <div>{{element.name !== ' '?element.name:`${element_wrapper.ifc_type.toLowerCase()} ${index+1}`}}</div>
                  <div class="d-flex">
                    <div class="mr-3 step-elements-total-value-noborder">{{calcStepTotal(step, step_type, [element.id]).total_mass}} {{getMassRelationUnit(step.mass_relation)}}</div>
                    <div class="step-elements-total-value-noborder" v-if="step.mass_relation !== 'none'">{{calcStepTotal(step, step_type, [element.id]).value}} {{calcStepTotal(step, step_type, [element.id]).unit}}</div>
                  </div>
                </div>
              </template>
            </div>
            </div>
          </template>
          <div v-else>
            <div :style="`color: ${'#fff'}`">No Elements Linked</div>
          </div>
        </template>
      </template>
      </CollapsableCategory> -->

    </template>
  </WorkPackageSubPageModule>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';

  import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
  import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
  import ModularEquation from '@/modules/WorkPackageWIP/ModularEquation.module.vue';
  import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
  import LabelOutlined from '@/components/WorkPackageWIP/LabelOutlined.component.vue';
  import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
  import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
  import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';

  import { TrainTaktareaDetailsMixin } from '@/mixins/TrainTaktareaDetails.mixin.js'


  export default {
    props: [],
    components: {
      RadialCheckbox,
      TextArea,
      ModularEquation,
      WorkPackageSubPageModule,
      LabelOutlined,
      ButtonOutlined,
      DisableableInputField,
      DropDownOutlinedFlat,
    },
    mixins: [
      TrainTaktareaDetailsMixin
    ],
    data: () => ({
    }),
    computed: {
      step_type(){
        return this.$route.params.step_type;
      },
      step(){
        return this.getUObject({type:`t${this.step_type.toLowerCase()}steps`, id: this.$route.params.step_id});
      },
      ...mapGetters('Auth', [
        'hasPermission',
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'updateUObject',
        'updateUObjectRelations',
      ]),
    }
  }

</script>
<style>
  .work-package-step-detail-status-container {
    display: flex;
    grid-gap: 8px;
    width: 100%;
  }
  .work-package-step-detail-status-button {
    flex-grow: 1;
  }
  .step-elements-total-value {
    display: flex;
    justify-content: flex-end;
    border: 1px solid;
    border-radius: 3px;
    padding: 1px;
    width: 60px;
    font-weight: 300;
    font-size: 10pt;
  }
  .step-elements-total-value-noborder {
    display: flex;
    justify-content: flex-end;
    width: 60px;
    font-weight: 300;
    font-size: 10pt;
  }
  .step-elements-calculation {
    font-weight: 300;
    font-size: 10pt;
    justify-content: flex-end;
    align-items: center;
    border-bottom: 1px solid;
    padding-bottom: 4px;
  }
  .step-elements-calculation-operator {
    display: flex;
    justify-content: center;
    width: 12px;
  }
  .step-elements-wrapper {
    font-weight: 300;
    font-size: 12pt;
  }
</style>
